import { FC } from 'react';
import { HStack, Skeleton } from '@chakra-ui/react';

import SunshineIcon from '../../../../../components/_core/SunshineIcon';

export const LoadingIntervalSkeleton: FC = () => (
  <HStack
    alignSelf="flex-start"
    border="1px solid"
    borderColor="card-borderColor"
    borderRadius="radius-6"
    height="40px"
    justifyContent="center"
    padding="space-8"
    paddingLeft="space-12"
    width="316px"
  >
    <Skeleton
      borderRadius="radius-24"
      endColor="grey.300"
      height="6px"
      startColor="grey.100"
      width="100%"
    />
    <SunshineIcon color="grey.300" name="chevron-down" size="icon-24" />
  </HStack>
);
